// import { log } from '@libs/utils/log/log';
import { parseQuery } from '@libs/utils/url/url';

interface FeatureDictionary {
    [featureName: string]: boolean;
}

let activeFeatures: FeatureDictionary | null = null;

function getFeaturesInQuery(): FeatureDictionary {
    const query = parseQuery(window.location.search);
    const result: FeatureDictionary = {};

    const btf = query?.btf;
    if (btf) {
        const features = Array.isArray(btf) ? btf : [btf];
        for (let featureName of features) {
            let isActive = true;
            if (featureName.startsWith('!')) {
                featureName = featureName.slice(1);
                isActive = false;
            }
            result[featureName] = isActive;
        }
    }

    return result;
}

function getFeaturesInStore(): FeatureDictionary {
    let storedValue: string | null = null;

    try {
        storedValue = window.localStorage?.getItem('btf');
    } catch {
        // Error accessing localStorage - silently continue
        // log('Error accessing localStorage', error);
    }

    let result: FeatureDictionary = {};

    if (storedValue !== null) {
        try {
            result = JSON.parse(storedValue);
        } catch {
            // Error parsing stored features - use empty object
            // log('Error getting features from store', error);
        }
    }

    return result;
}

function storeFeatures(features: FeatureDictionary): void {
    try {
        if (!window.localStorage) {
            return;
        }

        window.localStorage.setItem('btf', JSON.stringify(features));
    } catch {
        // Error storing features - silently continue
        //  log('Error storing features', error);
    }
}

function getActiveFeatures(): FeatureDictionary {
    if (activeFeatures === null) {
        const queryFeatures = getFeaturesInQuery();
        const storedFeatures = getFeaturesInStore();

        activeFeatures = {
            ...storedFeatures,
            ...queryFeatures,
        };

        storeFeatures(activeFeatures);
    }

    return activeFeatures;
}

export function feature(featureName: string): boolean {
    const features = getActiveFeatures();

    return featureName in features && features[featureName];
}
